import ClinicChoicePage from '@/pages/ClinicChoicePage/ClinicChoicePage.vue'

export default ClinicChoicePage
